import React, { useEffect, useMemo, useState } from 'react';

import successBg from '@/assets/details/successBg.png';
import icon_party from '@/assets/emoji/party-popper.png';
import { useAppSelector } from 'store/hooks';
import MintWallet from './MintWallet';

const WalletCollected = () => {
  const {
    raffleInfo: { whitelist_method },
  } = useAppSelector((state) => state.raffleDetails);
  const [raffleWhitelistMethod, setRaffleWhitelistMethod] = useState('');

  useEffect(() => {
    setRaffleWhitelistMethod(String(whitelist_method));
  }, [whitelist_method]);

  const textRender = useMemo(() => {
    if (raffleWhitelistMethod === 'DTC') {
      return <div>You submitted your wallet</div>;
    } else {
      return (
        <div>
          You submitted your wallet, Check the raffle page for more info.
        </div>
      );
    }
  }, [raffleWhitelistMethod]);

  return (
    <div>
      <div className="automateBg -mx-5 -mt-6 rounded-t-2xl ">
        <div
          className="bg-cover bg-repeat px-5 py-6 text-center "
          style={{ backgroundImage: `url(${successBg.src})` }}
        >
          <div className=" flex items-center justify-center text-center">
            <img src={icon_party.src} className="mr-1 w-8" alt="" />
            <span className="break-words text-xl font-semibold text-neutral-1000">
              Wallet address has been collected
            </span>
          </div>
          <div className="rounded-2xl bg-[rgba(0,0,0,0.6)] p-3 text-center text-base font-normal">
            <div className="text-neutral-200 ">You submitted:</div>
            <div className="mt-2 break-all text-neutral-200">
              <MintWallet />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4 text-center text-sm font-normal text-neutral-300">
        {textRender}
      </div>
    </div>
  );
};

export default WalletCollected;
